import { APNTag } from '../apntag/';

const idsMap: Record<string, number> = {};
const summonId = (id: string) => {
  if (!idsMap[id]) {
    idsMap[id] = 1;
    return id;
  }

  const newId = [id, ++idsMap[id]].join('_');
  return newId;
};

export class DisplayAdComponent extends HTMLElement {
  adId: string = '';
  sizes: [number, number][] = [];
  coreService = {
    onShowGTMEvent(adId: string[], isRefresh: boolean, details: any) {
      console.log(adId, isRefresh, details);
    },
  };

  constructor() {
    super();
  }

  connectedCallback() {
    this.adId = summonId(this.getAttribute('data-id') || 'default_ad_slot');
    this.sizes = JSON.parse(this.getAttribute('dimensions') || '[]');
    this.createAdUnit();
    this.render();
  }

  createAdUnit() {
    APNTag.getInstance().defineTag(
      this.adId,
      this.sizes,
      this,
    );
  }

  render() {
    this.style.display = 'block';
    this.style.position = 'relative';
    this.innerHTML = `<div id="${this.adId}" style="width: ${this.getMaxWidth()}px; height: ${this.getMaxHeight()}px;"></div><div style="position: absolute; left: 0; top: 0; opacity: .5; background: #fff; color: #000; font-size: 9px; padding: 2px 4px;">Ad</div>`;
  }

  onShow(ids: string[], params: any) {
    const isRefresh = parseInt(this.dataset.refreshCount || '0') > 0; 
    this.dispatchEvent(new CustomEvent('display-ads:show', { id: ids[0], isRefresh, ...params }));
    this.style.visibility = params.nobid ? 'hidden' : 'visible';
    this.coreService.onShowGTMEvent(ids, isRefresh, params);
  }

  disconnectedCallback() {

  }

  protected getMaxWidth() {
    return Math.max(...this.sizes.map(s => s[0]));
  }

  protected getMaxHeight() {
    return Math.max(...this.sizes.map(s => s[1]));
  }
}


